import React, { createContext, useContext, useReducer } from "react";

type OPEN_DRAWER = { type: "OPEN_DRAWER" };
type CLOSE_DRAWER = { type: "CLOSE_DRAWER" };
type OPEN_LINK = { type: "OPEN_LINK" };
type SLIDE_TO_ELEMENT = { type: "SLIDE_TO_ELEMENT" };
type Action = OPEN_DRAWER | CLOSE_DRAWER | OPEN_LINK | SLIDE_TO_ELEMENT;

interface State {
  isDrawerOpen: boolean;
}

const initialState: State = {
  isDrawerOpen: false,
};

const PageStateContext = createContext<
  { state: State; dispatch: React.Dispatch<Action>; primaryButtonDarkLabel?: boolean } | undefined
>(undefined);

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "OPEN_DRAWER":
      return { ...state, isDrawerOpen: true };
    case "CLOSE_DRAWER":
      return { ...state, isDrawerOpen: false };
    default:
      return state;
  }
};

export const PageStateProvider: React.FC<{ children: React.ReactNode; primaryButtonDarkLabel?: boolean }> = ({
  children,
  primaryButtonDarkLabel,
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <PageStateContext.Provider value={{ state, dispatch, primaryButtonDarkLabel }}>
      {children}
    </PageStateContext.Provider>
  );
};

export const usePageState = () => {
  const context = useContext(PageStateContext);
  if (!context) {
    throw new Error("usePageState must be used within a PageStateProvider");
  }
  return context;
};
